import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import InputField from 'components/Form/Fields/InputField';
import { Button, Grid, Message } from 'semantic-ui-react';
import Portal from 'components/Portal/Portal';
import CountryCodeField from 'components/Form/Fields/CountryCodeField';

export default function RetryShipmentForm({
  shipment,
  onUpdateShipment = () => {},
}) {
  return (
    <Formik
      initialValues={{
        attention_of: shipment.attention_of || '',
        client_name: shipment.client_name || '',
        client_address: shipment.client_address || '',
        client_postal_code: shipment.client_postal_code || '',
        client_phone: shipment.client_phone || '',
        client_city: shipment.client_city || '',
        client_email: shipment.client_email || '',
        client_country_code: shipment.client_country_code || 'es',
      }}
      validationSchema={Yup.object({
        attention_of: Yup.string().required('Campo requerido'),
        client_name: Yup.string().required('Campo requerido'),
        client_address: Yup.string()
          .max(120, 'Debe tener como máximo 120 caracteres')
          .required('Campo requerido'),
        client_postal_code: Yup.string().required('Campo requerido'),
        client_phone: Yup.string().required('Campo requerido'),
        client_city: Yup.string().required('Campo requerido'),
        client_email: Yup.string()
          .email('Dirección de e-mail incorrecta')
          .required('Campo requerido'),
        client_country_code: Yup.string().required('Campo requerido'),
      })}
      onSubmit={(values, { setSubmitting }) => {
        onUpdateShipment({ ...values });
        setSubmitting(false);
      }}
    >
      {(props) => (
        <Form>
          <Grid>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <InputField
                label="A la atención de"
                name="attention_of"
                type="text"
                placeholder="A la atención de"
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <InputField
                label="Nombre"
                name="client_name"
                type="text"
                placeholder="Cliente"
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <InputField
                label="Teléfono"
                name="client_phone"
                type="text"
                placeholder="Teléfono"
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <InputField
                label="E-mail"
                name="client_email"
                type="email"
                placeholder="Correo electrónico"
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <InputField
                label="Dirección"
                name="client_address"
                type="text"
                placeholder="Dirección"
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <InputField
                label="Código postal"
                name="client_postal_code"
                type="text"
                placeholder="Código postal"
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <InputField
                label="Ciudad"
                name="client_city"
                type="text"
                placeholder="Ciudad"
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <CountryCodeField
                label="País"
                name="client_country_code"
                type="text"
                placeholder="País"
                onChange={(event, { value }) =>
                  props.setFieldValue('client_country_code', value)
                }
              />
            </Grid.Column>
          </Grid>
          <Portal.In target="card-header">
            <Button
              type="submit"
              primary
              loading={props.isSubmitting}
              disabled={
                props.isSubmitting ||
                !props.isValid ||
                !['FIXING', 'INVALID'].includes(shipment.status)
              }
              onClick={(event, data) => props.handleSubmit()}
            >
              Actualizar envío
            </Button>
          </Portal.In>
          {props.dirty && (
            <Message warning size="mini" style={{ marginTop: 20 }}>
              Hay cambios sin guardar
            </Message>
          )}
        </Form>
      )}
    </Formik>
  );
}
